import React from 'react';
import './ErrorMessage.css';

const ErrorMessage = ({ 
  message = "Oops! Something magical went wrong.", 
  details = null,
  onRetry = null,
  onDismiss = null,
  severity = "error" // 'error', 'warning', or 'info'
}) => {
  // Icon selection based on severity level
  const getIcon = () => {
    switch(severity) {
      case 'error': return '🧙‍♂️'; // Wizard for errors
      case 'warning': return '⚠️'; // Standard warning
      case 'info': return '✨'; // Sparkle for info
      default: return '📜'; // Scroll as fallback
    }
  };
  
  // Child-friendly messages if none provided
  const getFriendlyMessage = () => {
    if (message) return message;
    
    switch(severity) {
      case 'error': 
        return "Oh no! Our magical story spell has fizzled out.";
      case 'warning':
        return "Hmm, our crystal ball is a bit foggy right now.";
      case 'info':
        return "Just a magical update for you!";
      default:
        return "Something unexpected happened in our enchanted realm.";
    }
  };

  return (
    <div className={`error-message ${severity}`}>
      <div className="error-icon">
        {getIcon()}
      </div>
      
      <div className="error-content">
        <h3>{getFriendlyMessage()}</h3>
        {details && <p>{details}</p>}
        
        <div className="error-actions">
          {onRetry && (
            <button 
              className="error-action-button retry" 
              onClick={onRetry}
              aria-label="Try again"
            >
              Try Again ✨
            </button>
          )}
          
          {onDismiss && (
            <button 
              className="error-action-button dismiss" 
              onClick={onDismiss}
              aria-label="Dismiss message"
            >
              Dismiss
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ErrorMessage;
